// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payPage[data-v-c7c4a164]{width:1200px;margin:0 auto}.payPage .pay[data-v-c7c4a164]{color:#67c23a}.payPage .pay i[data-v-c7c4a164]{font-size:80px;margin-top:50px;margin-bottom:18px}.payPage .pay p[data-v-c7c4a164]{display:flex;align-items:center;justify-content:center;text-align:center;font-size:28px;line-height:50px}.payPage .pay .el-button[data-v-c7c4a164]{margin-left:20px}.centerIE[data-v-c7c4a164]{transform:translate(45%)}", ""]);
// Exports
module.exports = exports;
